var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8904 28C2.14638 18.6667 -9.74061 -0.00012692 12.8904 6.47224e-10C34.1499 0.000119232 23.6344 18.6667 12.8904 28ZM12.6 14C15.6928 14 18.2 12.433 18.2 10.5C18.2 8.567 15.6928 7 12.6 7C9.50721 7 7 8.567 7 10.5C7 12.433 9.50721 14 12.6 14Z",
    fill: "#D9794B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacemark);
export default __webpack_public_path__ + "static/media/placemark.5beec7b9e972dafa08ba7a8fe1e7336d.svg";
export { ForwardRef as ReactComponent };